import { useForm } from "react-hook-form";
import useWilmaUsers from "../../../data/useWilmaUsers";
import SelectInput from "../Inputs/SelectInput";
import { useEffect, useState } from "react";

export default function WilmaUserSelect({
  label,
  value,
  setValue,
  watch,
  register,
  registerName,
  includeDeleted = false,
}: {
  label: string;
  value: string;
  register: any;
  registerName: string;
  setValue: any;
  watch: any;
  includeDeleted?: boolean;
}) {
  const { wilmaUsers } = useWilmaUsers(includeDeleted);

  const [users, setUsers] = useState<{ id: string; name: string }[]>([{ id: "", name: "Unassigned" }]);

  useEffect(() => {
    if (wilmaUsers.data?.data) {
      const mappedUsers = wilmaUsers.data.data.map((user) => ({
        id: user.id,
        name: user.fullname,
      }));
      setUsers([{ id: "", name: "Unassigned" }, ...mappedUsers]);
    }
  }, [wilmaUsers.data]);

  return (
    <SelectInput 
      label={label} register={register} registerName={registerName} options={users} setValue={setValue} watch={watch} rounded
    />
  );
}
